module.exports = __webpack_public_path__ + "img/skiing001.597f40f2.jpg";